var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHomeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3549 259.629H61.0776V450.583C61.0776 464.295 70.219 475.976 88.5018 475.976H170.775C185.502 475.976 195.152 462.772 195.152 451.599V313.462H304.848V451.599C304.848 462.772 314.498 475.976 329.225 475.976H411.498C429.781 475.976 438.922 464.295 438.922 450.583V259.629H485.645C496.31 259.629 504.944 245.409 493.771 235.252C482.598 225.095 269.298 33.1257 269.298 33.1257C269.298 33.1257 260.157 25 250 25C239.843 25 230.702 33.1257 230.702 33.1257C230.702 33.1257 17.4021 225.095 6.22922 235.252C-4.94366 245.409 3.68998 259.629 14.3549 259.629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHomeFill);
export default __webpack_public_path__ + "static/media/ico_home_fill.f7d5d681ca9003982bb829f5d5cf9b13.svg";
export { ForwardRef as ReactComponent };